import { Txt } from '@vst/beam';

import { hexToRgba } from '@app/utils';

import { getAddonImagePropsByKind } from '../AddonIcon';
import { useDisclosureListItems } from './useDisclosureListItems';

import styles from './styles.module.scss';

const ProductDisclosure = ({ name, listItems }: { name: string; listItems: string[] }) => {
  return (
    <div className={styles['unorderedList']}>
      <Txt variant="bodySmallBold">{name}</Txt>
      <ul style={{ margin: 0, paddingLeft: 20 }}>
        {listItems.map((item: string, index: number) => (
          <li key={item}>
            <Txt variant="bodySmallRegular" style={{ marginBottom: 0 }}>
              {item}
            </Txt>
          </li>
        ))}
      </ul>
    </div>
  );
};

export const DisclosureCard = ({ name, kind }: { name: string; kind: string }) => {
  const { backgroundColor, icon: Icon, hexColorValue } = getAddonImagePropsByKind(kind);
  const hexBackgroundColor = hexToRgba(backgroundColor, 0.3);
  const iconHexBackgroundColor = hexToRgba(backgroundColor, 0);

  const listItems = useDisclosureListItems(kind);

  return (
    <div style={{ background: `${hexBackgroundColor}` }} className={styles['disclosure']}>
      <div style={{ color: hexColorValue, backgroundColor: iconHexBackgroundColor }} className={styles['icon']}>
        <Icon width={80} height={80} />
      </div>
      <ProductDisclosure name={name} listItems={listItems} />
    </div>
  );
};
